import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TagForm from '../TagForm/TagForm';
import { TAG_FORM_DEFAULT_VALUES } from '../TagForm/constants';
import { useModals } from 'hooks/useModals';
import { TTagsAdd } from './TagsAdd.types';
import { useAppDispatch } from 'store/store';
import {
  createTagAsyncThunk,
  getTagsListAsyncThunk,
} from 'store/tags/tags.action';
import { TTagFormValues } from '../TagForm/TagForm.types';
import { getTagFormSchema } from '../TagForm/TagForm.schema';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { getLocalizationList } from 'store/localization/localization.action';
import { ESupportedLocales } from 'store/localization/localization.enums';

const TagsAdd: TTagsAdd = () => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const tagFormSchema = React.useMemo(
    () => getTagFormSchema(localize),
    [localize]
  );

  const form = useForm<TTagFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: TAG_FORM_DEFAULT_VALUES,
    resolver: yupResolver(tagFormSchema) as Resolver<TTagFormValues>,
  });

  const handleSubmit = (data: TTagFormValues) => {
    dispatch(
      createTagAsyncThunk({
        body: data,
        onSuccess: () => {
          modals.closeModal();
          dispatch(getLocalizationList({ locale: ESupportedLocales.EN }));
          dispatch(getTagsListAsyncThunk());
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <TagForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default TagsAdd;
